export default "/fonts/Flaticon.eot?ff4db9d699282a5e5f6ca4df550d4439";